import { render } from "./MobileHomeView.vue?vue&type=template&id=4c12e34e&scoped=true"
import script from "./MobileHomeView.vue?vue&type=script&lang=js"
export * from "./MobileHomeView.vue?vue&type=script&lang=js"

import "./MobileHomeView.vue?vue&type=style&index=0&id=4c12e34e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c12e34e"]])

export default __exports__